/* eslint-disable @typescript-eslint/naming-convention */
// TODO: create nx generator to replicate https://github.com/FlutterInt/fips-sw-web-client/blob/develop/config/generators/time-zone-abbreviations/index.js
export default {
  'Acre Time': 'ACT',
  'Afghanistan Time': 'AFT',
  'Al Manamah Standard Time': 'AST',
  'Alaska Daylight Saving Time': 'ADST',
  'Alaska Daylight Time': 'AKDT',
  'Alaska Standard Time': 'AKST',
  'Alaska Time': 'AT',
  'Alfa Time Zone': 'A',
  'Alma-Ata Time': 'ALMT',
  'Amazon Summer Time': 'AMST',
  'Amazon Time': 'AMT',
  'Anadyr Summer Time': 'ANAST',
  'Anadyr Time': 'ANAT',
  'Anywhere on Earth': 'AoE',
  'Aqtobe Time': 'AQTT',
  'Arabia Daylight Time': 'ADT',
  'Arabia Standard Time': 'AST',
  'Arabia Summer Time': 'AST',
  'Arabic Standard Time': 'AST',
  'Argentina Standard Time': 'ART',
  'Argentina Time': 'ART',
  'Armenia Daylight Time': 'AMDT',
  'Armenia Summer Time': 'AMST',
  'Armenia Time': 'AMT',
  'Atlantic Daylight Saving Time': 'ADST',
  'Atlantic Daylight Time': 'ADT',
  'Atlantic Standard Time': 'AST',
  'Atlantic Summer Time': 'AST',
  'Atlantic Time': 'AT',
  'Australian Central Daylight Time': 'ACDT',
  'Australian Central Standard Time': 'ACST',
  'Australian Central Time': 'ACT',
  'Australian Central Western Standard Time': 'ACWST',
  'Australian Eastern Daylight Time': 'AEDT',
  'Australian Eastern Standard Time': 'AEST',
  'Australian Eastern Time': 'AET',
  'Australian Western Daylight Time': 'AWDT',
  'Australian Western Standard Time': 'AWST',
  'Azerbaijan Summer Time': 'AZST',
  'Azerbaijan Time': 'AZT',
  'Azores Daylight Time': 'AZODT',
  'Azores Standard Time': 'AZOST',
  'Azores Summer Time': 'AZOST',
  'Azores Time': 'AZOT',
  'Bangladesh Standard Time': 'BST',
  'Bhutan Time': 'BTT',
  'Bolivia Time': 'BOT',
  'Bougainville Standard Time': 'BST',
  'Brasília Summer Time': 'BRST',
  'Brasília Time': 'BRT',
  'Bravo Time Zone': 'B',
  'Brazil Summer Time': 'BST',
  'Brazil Time': 'BT',
  'Brazilian Summer Time': 'BST',
  'Brazilian Time': 'BT',
  'British Daylight Saving Time': 'BDST',
  'British Daylight Time': 'BDT',
  'British Summer Time': 'BST',
  'Brunei Darussalam Time': 'BNT',
  'Brunei Time': 'BDT',
  'Cape Verde Time': 'CVT',
  'Casey Time': 'CAST',
  'Cayman Islands Daylight Saving Time': 'CIDST',
  'Cayman Islands Standard Time': 'CIST',
  'Cayman Islands Time': 'CIT',
  'Central Africa Time': 'CAT',
  'Central Daylight Saving Time': 'CDST',
  'Central Daylight Savings Time': 'CDST',
  'Central Daylight Time': 'CDT',
  'Central Europe Time': 'CET',
  'Central European Daylight Time': 'CEDT',
  'Central European Summer Time': 'CEST',
  'Central European Time': 'CET',
  'Central Indonesian Time': 'WITA',
  'Central Standard Time': 'CST',
  'Central Time': 'CT',
  'Chamorro Standard Time': 'ChST',
  'Charlie Time Zone': 'C',
  'Chatham Daylight Time': 'CDT',
  'Chatham Island Daylight Time': 'CHADT',
  'Chatham Island Standard Time': 'CHAST',
  'Chile Daylight Time': 'CLDT',
  'Chile Standard Time': 'CLST',
  'Chile Summer Time': 'CLST',
  'Chile Time': 'CT',
  'China Standard Time': 'CST',
  'Choibalsan Daylight Saving Time': 'CHODST',
  'Choibalsan Daylight Time': 'CHODT',
  'Choibalsan Summer Time': 'CHOST',
  'Choibalsan Time': 'CHOT',
  'Christmas Island Time': 'CXT',
  'Chuuk Time': 'CHUT',
  'Cocos Islands Time': 'CCT',
  'Colombia Time': 'COT',
  'Cook Island Time': 'CKT',
  'Coordinated Universal Time': 'UTC',
  'Cuba Daylight Time': 'CDT',
  'Cuba Standard Time': 'CST',
  'Davis Time': 'DAVT',
  'Delta Time Zone': 'D',
  "Dumont-d'Urville Time": 'DDUT',
  'East Africa Time': 'EAT',
  'East Greenland Summer Time': 'EGST',
  'East Greenland Time': 'EGT',
  'East Timor Time': 'TLT',
  'Easter Island Daylight Time': 'EADT',
  'Easter Island Standard Time': 'EAST',
  'Easter Island Summer Time': 'EASST',
  'Eastern Africa Time': 'EAT',
  'Eastern Daylight Saving Time': 'EDST',
  'Eastern Daylight Savings Time': 'EDST',
  'Eastern Daylight Time': 'EDT',
  'Eastern European Daylight Time': 'EEDT',
  'Eastern European Summer Time': 'EEST',
  'Eastern European Time': 'EET',
  'Eastern Greenland Summer Time': 'EGST',
  'Eastern Greenland Time': 'EGT',
  'Eastern Indonesian Time': 'WIT',
  'Eastern Standard Time': 'EST',
  'Eastern Time': 'ET',
  'Echo Time Zone': 'E',
  'Ecuador Time': 'ECT',
  'Efate Time': 'EFATE',
  'European Central Summer Time': 'ECST',
  'European Central Time': 'ECT',
  'Falkland Island Daylight Time': 'FKDT',
  'Falkland Island Standard Time': 'FKST',
  'Falkland Island Time': 'FKT',
  'Falkland Islands Summer Time': 'FKST',
  'Fernando de Noronha Time': 'FNT',
  'Fiji Daylight Time': 'FJDT',
  'Fiji Summer Time': 'FJST',
  'Fiji Time': 'FJT',
  'Foxtrot Time Zone': 'F',
  'French Guiana Time': 'GFT',
  'French Southern and Antarctic Time': 'TFT',
  'Further-Eastern European Time': 'FET',
  'Galapagos Time': 'GALT',
  'Gambier Islands Time': 'GAMT',
  'Gambier Time': 'GAMT',
  'Georgia Standard Time': 'GET',
  'Gilbert Island Time': 'GILT',
  'Golf Time Zone': 'G',
  'Greenwich Mean Time': 'GMT',
  'Greenwich Time': 'GT',
  'Guam Standard Time': 'GST',
  'Gulf Standard Time': 'GST',
  'Guyana Time': 'GYT',
  'Hawaii Daylight Time': 'HADT',
  'Hawaii Standard Time': 'HST',
  'Hawaii-Aleutian Daylight Time': 'HDT',
  'Hawaii-Aleutian Standard Time': 'HAST',
  'Heure Avancée de Terre-Neuve (French)': 'HAT',
  "Heure Avancée de l'Atlantique (French)": 'HAA',
  "Heure Avancée de l'Est (French)": 'HAE',
  'Heure Avancée des Rocheuses (French)': 'HAR',
  'Heure Avancée du Centre (French)': 'HAC',
  'Heure Avancée du Pacifique (French)': 'HAP',
  'Heure Normale de Terre-Neuve (French)': 'HNT',
  "Heure Normale de l'Atlantique (French)": 'HNA',
  "Heure Normale de l'Est (French)": 'HNE',
  'Heure Normale des Rocheuses (French)': 'HNR',
  'Heure Normale du Centre (French)': 'HNC',
  'Heure Normale du Pacifique (French)': 'HNP',
  'Hong Kong Time': 'HKT',
  'Hora Legal de Venezuela (Spanish)': 'HLV',
  'Hotel Time Zone': 'H',
  'Hovd Daylight Saving Time': 'HOVDST',
  'Hovd Daylight Time': 'HOVDT',
  'Hovd Summer Time': 'HOVST',
  'Hovd Time': 'HOVT',
  'India Standard Time': 'IST',
  'India Time': 'IT',
  'India Time Zone': 'I',
  'Indian Chagos Time': 'IOT',
  'Indian Standard Time': 'IST',
  'Indochina Time': 'ICT',
  'Iran Daylight Time': 'IDT',
  'Iran Standard Time': 'IRST',
  'Iran Summer Time': 'IRST',
  'Iran Time': 'IT',
  'Irish Standard Time': 'IST',
  'Irish Summer Time': 'IST',
  'Irkutsk Summer Time': 'IRKST',
  'Irkutsk Time': 'IRKT',
  'Israel Daylight Time': 'IDT',
  'Israel Standard Time': 'IST',
  'Japan Standard Time': 'JST',
  'Kamchatka Summer Time': 'PETST',
  'Kamchatka Time': 'PETT',
  'Kerguelen (Islands) Time': 'KIT',
  'Kilo Time Zone': 'K',
  'Korea Standard Time': 'KST',
  'Korea Time': 'KT',
  'Korean Standard Time': 'KST',
  'Kosrae Time': 'KOST',
  'Krasnoyarsk Summer Time': 'KRAST',
  'Krasnoyarsk Time': 'KRAT',
  'Kuybyshev Time': 'KUYT',
  'Kyrgyzstan Time': 'KGT',
  'Lima Time Zone': 'L',
  'Line Islands Time': 'LINT',
  'Lord Howe Daylight Time': 'LHDT',
  'Lord Howe Standard Time': 'LHST',
  'Magadan Island Summer Time': 'MAGST',
  'Magadan Island Time': 'MAGT',
  'Magadan Summer Time': 'MAGST',
  'Magadan Time': 'MAGT',
  'Malaysia Time': 'MYT',
  'Malaysian Standard Time': 'MST',
  'Maldives Time': 'MVT',
  'Marquesas Time': 'MART',
  'Marshall Islands Time': 'MHT',
  'Mauritius Time': 'MUT',
  'Mawson Time': 'MAWT',
  'Mike Time Zone': 'M',
  'Mitteleuropäische Sommerzeit (German)': 'MESZ',
  'Mitteleuropäische Zeit (German)': 'MEZ',
  'Moscow Daylight Time': 'MSD',
  'Moscow Standard Time': 'MSK',
  'Moscow Summer Time': 'MSD',
  'Moscow Time': 'MCK',
  'Mountain Daylight Saving Time': 'MDST',
  'Mountain Daylight Time': 'MDT',
  'Mountain Standard Time': 'MST',
  'Mountain Time': 'MT',
  'Myanmar Time': 'MMT',
  'Nauru Time': 'NRT',
  'Nepal Time': 'NPT',
  'New Caledonia Time': 'NCT',
  'New Zealand Daylight Time': 'NZDT',
  'New Zealand Standard Time': 'NZST',
  'Newfoundland Daylight Time': 'NDT',
  'Newfoundland Standard Time': 'NST',
  'Niue Time': 'NUT',
  'Norfolk Daylight Time': 'NFDT',
  'Norfolk Island Daylight Time': 'NFDT',
  'Norfolk Island Time': 'NFT',
  'Norfolk Time': 'NFT',
  'North American Central Daylight Time': 'NACDT',
  'North American Central Standard Time': 'NACST',
  'North American Eastern Daylight Time': 'NAEDT',
  'North American Eastern Standard Time': 'NAEST',
  'North American Mountain Daylight Time': 'NAMDT',
  'North American Mountain Standard Time': 'NAMST',
  'North American Pacific Daylight Time': 'NAPDT',
  'North American Pacific Standard Time': 'NAPST',
  'November Time Zone': 'N',
  'Novosibirsk Summer Time': 'NOVST',
  'Novosibirsk Time': 'NOVT',
  'Omsk Standard Time': 'OMST',
  'Omsk Summer Time': 'OMSST',
  'Omsk Time': 'OMST',
  'Oral Time': 'ORAT',
  'Oscar Time Zone': 'O',
  'Osteuropäische Sommerzeit (German)': 'OESZ',
  'Osteuropäische Zeit (German)': 'OEZ',
  'Pacific Daylight Saving Time': 'PDST',
  'Pacific Daylight Time': 'PDT',
  'Pacific Standard Time': 'PST',
  'Pacific Time': 'PT',
  'Pakistan Standard Time': 'PKT',
  'Pakistan Time': 'PKT',
  'Palau Time': 'PWT',
  'Papa Time Zone': 'P',
  'Papua New Guinea Time': 'PGT',
  'Paraguay Summer Time': 'PYST',
  'Paraguay Time': 'PYT',
  'Peru Time': 'PET',
  'Petropavlovsk-Kamchatski Time': 'PETT',
  'Philippine Standard Time': 'PST',
  'Philippine Time': 'PHT',
  'Phoenix Island Time': 'PHOT',
  'Pierre & Miquelon Daylight Time': 'PMDT',
  'Pierre & Miquelon Standard Time': 'PMST',
  'Pitcairn Standard Time': 'PST',
  'Pohnpei Standard Time': 'PONT',
  'Pyongyang Standard Time': 'PYST',
  'Pyongyang Time': 'PYT',
  'Quebec Time Zone': 'Q',
  'Qyzylorda Time': 'QYZT',
  'Reunion Time': 'RET',
  'Romeo Time Zone': 'R',
  'Rothera Time': 'ROTT',
  'Sakhalin Time': 'SAKT',
  'Samara Standard Time': 'SAMT',
  'Samara Summer Time': 'SAMST',
  'Samara Time': 'SAMT',
  'Samoa Standard Time': 'SST',
  'Samoa Time': 'ST',
  'Seychelles Time': 'SCT',
  'Sierra Time Zone': 'S',
  'Singapore Standard Time': 'SST',
  'Singapore Time': 'SGT',
  'Solomon Island Time': 'SBT',
  'Solomon Islands Time': 'SBT',
  'South Africa Standard Time': 'SAST',
  'South African Standard Time': 'SAST',
  'South Georgia Time': 'GST',
  'Srednekolymsk Time': 'SRET',
  'Suriname Time': 'SRT',
  'Syowa Time': 'SYOT',
  'Tahiti Time': 'TAHT',
  'Tajikistan Time': 'TJT',
  'Tango Time Zone': 'T',
  'Tiempo Central Estándar (Spanish)': 'CST',
  'Tiempo Estándar del Atlántico (Spanish)': 'AST',
  'Tiempo de verano del Este (Spanish)': 'EDT',
  'Tiempo del Este (Spanish)': 'ET',
  'Tiempo del Pacifico (Spanish)': 'PT',
  'Tokelau Time': 'TKT',
  'Tonga Summer Time': 'TOST',
  'Tonga Time': 'TOT',
  'Turkey Time': 'TRT',
  'Turkmenistan Time': 'TMT',
  'Tuvalu Time': 'TVT',
  'Ulaanbaatar Summer Time': 'ULAST',
  'Ulaanbaatar Time': 'ULAT',
  'Ulan Bator Summer Time': 'ULAST',
  'Ulan Bator Time': 'ULAT',
  'Uniform Time Zone': 'U',
  'Uruguay Summer Time': 'UYST',
  'Uruguay Time': 'UYT',
  'Uzbekistan Time': 'UZT',
  'Vanuatu Time': 'VUT',
  'Venezuelan Standard Time': 'VET',
  'Victor Time Zone': 'V',
  'Vladivostok Summer Time': 'VLAST',
  'Vladivostok Time': 'VLAT',
  'Vostok Time': 'VOST',
  'Wake Time': 'WAKT',
  'Waktu Indonesia Barat': 'WIB',
  'Waktu Indonesia Tengah': 'WITA',
  'Waktu Indonesia Timur': 'WIT',
  'Wallis and Futuna Time': 'WFT',
  'West Africa Summer Time': 'WAST',
  'West Africa Time': 'WAT',
  'West Greenland Summer Time': 'WGST',
  'West Samoa Time': 'WST',
  'Western Argentine Summer Time': 'WARST',
  'Western Australia Time': 'WAT',
  'Western Daylight Time': 'WDT',
  'Western European Daylight Time': 'WEDT',
  'Western European Summer Time': 'WEST',
  'Western European Time': 'WET',
  'Western Greenland Summer Time': 'WGST',
  'Western Greenland Time': 'WGT',
  'Western Indonesian Time': 'WIB',
  'Western Sahara Standard Time': 'WT',
  'Western Sahara Summer Time': 'WST',
  'Western Sahara Time': 'WT',
  'Western Standard Time': 'WST',
  'Western Summer Time': 'WST',
  'Westeuropäische Sommerzeit (German)': 'WESZ',
  'Westeuropäische Zeit (German)': 'WEZ',
  'Whiskey Time Zone': 'W',
  'X-ray Time Zone': 'X',
  'Yakutsk Summer Time': 'YAKST',
  'Yakutsk Time': 'YAKT',
  'Yankee Time Zone': 'Y',
  'Yap Time': 'YAPT',
  'Yekaterinburg Summer Time': 'YEKST',
  'Yekaterinburg Time': 'YEKT',
  'Zulu Time Zone': 'Z'
};
